<script>
import { Uploader} from '@/components/shared'

export default {
  name: "editForm",
  components: {
    Uploader
  },
  data () {
    return {
      initializing: true,
      progressing: false,
      model: {
        user: {
          userName: null,
          firstName: null,
          lastName: null,
          email: null,
          phoneCode: this.$config.country.phoneCode,
          phoneNumber: null
        },
        profile: {
          gender: null,
          birthDate: null,
          image: null
        },
      },
      passwordConfirm: null,
    }
  },
  methods: {
    preSubmit () {
      return this.$validator.validateAll().then(isValid => {
        this.progressing = isValid
        return isValid
      })
    },
    fail (err) {
      this.$showError(this.$getLocaleErrorMessage(err, 'users'))
      this.progressing = false
      return false
    },
    success (successMessage, path) {
      this.$showSuccess(this.$t(successMessage))
      this.progressing = false
      this.goto(path)
    },
    goto (path) {
      if (path) this.$router.push({ path })
    }
  }
}
</script>
